import React, {useEffect, useState, Fragment} from "react";
import { connect } from "react-redux";

import {setLookOpened} from "../../../../actions/lookFunctions";
import GroheFeature from "./groheFeature/groheFeature";
import {LOOK_OVERLAYS} from "../../core/constants";
import GroheMobileFeature from "../groheMobile/groheMobileFeature/groheMobileFeature";
import GroheMobileFeatureAddedToTheCart from "../groheMobile/groheMobileFeature/groheMobileFeatureAddedToTheCart";
import {
  setGroheSimilarFeature,
  setGroheSimilarProductsOpened,
  setShowAddedToTheCartSuccess
} from "../../../../actions/groheFunctions";
import {usePrevious} from "../../../../misc/helperHooks";
import {zoomCanvasOut} from "../../lookNavigation/lookFunctions";
import {setCanvasScale} from "../../../../actions/actionFunctions";
import {getFeatureIsLocked} from "../../../../misc/helpers";
import {hideFeatureSection} from "../../lookNavigation/lookFunctions2";

const GroheSidebar = (props) => {

  const {lookOpened, isMobile, showAddedToTheCartSuccess, setShowAddedToTheCartSuccess, wizardActiveItem,
    lookActiveFeature, lookOverlayOpened, setGroheSimilarProductsOpened, setGroheSimilarFeature, imageCanvas,
    setCanvasScale, lookActiveCategory, shopPageOpened, lookCompatabilityAlert} = props;

  const [loadingCart, setLoadingCart] = useState(false);
  const prevOverlayOpened = usePrevious(lookOverlayOpened);

  // useEffect(() => {
    // setLookOpened(LOOK_OPENED_TYPES.featureZoom); // why do we need that?? removed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    if (showAddedToTheCartSuccess) {
      setShowAddedToTheCartSuccess(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveFeature]);

  useEffect(() => {
    if (lookOverlayOpened === LOOK_OVERLAYS.loadingCart) {
      setLoadingCart(true);
    } else if (!lookOverlayOpened) {
      if (loadingCart) {
        setLoadingCart(false);
        setGroheSimilarProductsOpened(true);
        setGroheSimilarFeature(lookActiveFeature);
        setShowAddedToTheCartSuccess(true);
      } else if (prevOverlayOpened === LOOK_OVERLAYS.questionView) {
        zoomCanvasOut(imageCanvas, setCanvasScale);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookOverlayOpened]);

  const getMobileContent = () => {
    return showAddedToTheCartSuccess ? <GroheMobileFeatureAddedToTheCart/> : <GroheMobileFeature/>
  }

  const showFeaturesOnly = !wizardActiveItem && hideFeatureSection(lookOpened, lookActiveCategory, lookActiveFeature, lookCompatabilityAlert);

  const locked = lookOpened && lookActiveFeature && getFeatureIsLocked(lookActiveFeature);

  return (
    <section className={"grohe-sidebar"
      + (lookOpened ? " grohe-sidebar--opened" : "")
      + (locked ? " grohe-sidebar--locked" : "")
      + (shopPageOpened ? " grohe-sidebar--shop" : "")
      + (showFeaturesOnly ? " grohe-sidebar--features-only" : "")}>
      {isMobile ? getMobileContent() : (
        <Fragment>
          <GroheFeature/>
        </Fragment>
      )}
    </section>
  )
};

const mapStateToProps = (store) => {
  const {lookOpened, lookActiveFeature, lookOverlayOpened, lookActiveCategory, lookCompatabilityAlert} = store.lookState;
  const {isMobile} = store.serverState;
  const {showAddedToTheCartSuccess} = store.groheState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in
  const {shopPageOpened} = store.shopState;
  const {wizardActiveItem} = store.wizardState;

  return {
    lookOpened,
    isMobile,
    showAddedToTheCartSuccess,
    lookActiveFeature,
    lookOverlayOpened,
    lookActiveCategory,
    isPhoneNumberValidated,
    shopPageOpened,
    wizardActiveItem,
    lookCompatabilityAlert,
  };
};

const mapDispatchToProps = {
  setLookOpened,
  setShowAddedToTheCartSuccess,
  setGroheSimilarProductsOpened,
  setGroheSimilarFeature,
  setCanvasScale
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheSidebar)
